<template>
  <div>
    <h3>客户保障查询</h3>
    <div class="searchBox">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="销售时间">
          <el-date-picker
            v-model="formInline.begin"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formInline.end"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="formInline.name"
            type="text"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件号">
          <el-input
            v-model="formInline.nationalId"
            type="text"
            placeholder="请输入证件号"
          ></el-input>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-select v-model="formInline.status" placeholder="结算状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="未结算" value="2"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售渠道" v-if="category != 1">
          <el-select
            v-model="formInline.subChannel"
            clearable
            placeholder="销售渠道"
          >
            <el-option
              v-for="(item, index) in listchannel"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售渠道" v-else>
          <el-select
            v-model="formInline.branchId"
            clearable
            placeholder="销售渠道"
          >
            <el-option
              v-for="(item, index) in listchannel"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button class="text2" type="primary" @click="getData()"
          >搜索</el-button
        >
        <el-button class="text2" type="primary" @click="exportsee"
          >导出</el-button
        >
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 350px)"
      >
        <el-table-column label="用户姓名" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.name || "待激活" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品名称" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.product.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.mobileno || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证件号码" align="center" width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.nationalId || "待激活" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="保障开始日期" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.detail.validFrom
                ? setTime(scope.row.detail.validFrom)
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="保障卡号" align="center">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="点击复制激活卡号"
              placement="top"
            >
              <a
                :data-clipboard-text="scope.row.detail.code"
                class="copeA icon-copy"
                >{{ scope.row.detail.code }}</a
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="policyNo"
          label="保单号"
          align="center"
          width="190px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.product.productGroup == 'G220'">
              <span >--</span>
            </span>
            <span v-else>
              <span v-if="!scope.row.detail.policyNo">--</span>
            <a
              v-else
              :href="scope.row.detail.policyUrl"
              target="_blank"
              class="blue"
              >{{ scope.row.detail.policyNo }}</a
            >
            </span>
          
          </template>
        </el-table-column>
        <el-table-column label="激活地址">
          <template slot-scope="scope">
            <div v-if="scope.row.detail.validFrom == undefined">
              <a
              :data-clipboard-text="scope.row.activeUrl"
              class="blue icon-copy"
              >复制激活地址</a
              >
              <div style="color:#00ABFA;cursor: pointer" @click="ckewm(scope.row.activeUrl)">查看二维码</div>
            </div>
            <!-- :logoSrc="imagePath" -->
            <span v-else>已激活</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.detail.subChannelName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column slot-scope="scope" v-if="scope.row.divisionDay == 1 || scope.row.divisionDay == 3"  label="天数">
					<template slot-scope="scope">
				
						<span >{{scope.row.continueDay}}日</span>
					</template>
				</el-table-column> -->
        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope">
            <span class="yellow">{{
              billingState[scope.row.detail.billingState]
            }}</span>
            <el-tooltip effect="dark" content="请先激活" placement="top">
              <span
                v-if="!scope.row.detail.validFrom"
                style="color: #ccc; cursor: pointer"
                >查看凭证</span
              >
            </el-tooltip>
            <template v-if="scope.row.detail.validFrom">
              <el-button
                v-if="!scope.row.detail.serviceCredential"
                type="text"
                disabled
                ><i class="el-icon-loading"></i>正在生成凭证</el-button
              >
              <a
                v-if="scope.row.detail.serviceCredential"
                :href="scope.row.detail.serviceCredential"
                target="_blank"
                class="blue"
                >查看凭证</a
              >
            </template>
            <template>
              <router-link
                class="blue"
                v-if="channelId == '2753' || channelId == '2137' || channelId == '2108'"
                :to="{
                  path: '/shop/order/orderDetails',
                  query: { id: scope.row.detail.id, type: 'type' },
                }"
                >查看详情</router-link
              >
              <router-link
                class="blue"
                v-else
                :to="{
                  path: '/shop/order/orderDetails',
                  query: { id: scope.row.detail.billingId },
                }"
                >查看详情</router-link
              >
            </template>
            <template>
              <el-button
                v-if="
                  scope.row.detail.billingState == 0 ||
                  scope.row.detail.billingState == 4 ||
                  (scope.row.detail.validFrom &&
                    scope.row.detail.validFrom < scope.row.detail.nowTime)
                "
                type="text"
                disabled
                >退单</el-button
              >
              <el-button
                v-else-if="
                  scope.row.detail.validFrom != undefined &&
                  scope.row.detail.parentId != null
                "
                type="text"
                disabled
                >退单</el-button
              >
              <el-button
                v-else
                type="text"
                @click="
                  centerDialogVisible = true;
                  exitData = scope.row.detail;
                "
                >退单</el-button
              >
              <!-- <span v-if="scope.row.detail.includeInsurance == 0">
                <el-button v-if="scope.row.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
            </template>

            <!-- <el-button v-if="scope.row.validFrom != undefined&&">开发票</el-button>
						<el-button v-else type='text'>开发票</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fenye">
      <pages
        class="pagination"
        :allpage="allpage"
        :changePage="changePage"
      ></pages>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <span>请确认退单？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureExit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="友情提示"
      :visible.sync="centerDialogVisible1"
      width="30%"
      center
    >
      <template v-for="(item, index) in exitData.invoices">
        <refundDialog
          :key="index"
          :fpdm="item.fpdm"
          :fphm="item.fphm"
          :prodectName="exitData.product.name"
        />
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
  title="二维码"
  :visible.sync="ewmcenterDialogVisible"
  width="30%">
  <vue-qr class='fukuanBox' style="text-align: center;" :logoSrc="imagePath"  :text="payImg" :size="300"></vue-qr>
  <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
    <el-button type="primary" @click="ewmcenterDialogVisible = false">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import {
  ordergetChannelBillDetailList,
  listDd,
  refund,
  downloadPdf,
  listchannel,
  userchannellist,
  getInfo,
} from "@/axios/api.js";
import common from "@/assets/common.js";
import Clipboard from "clipboard";
import { Loading } from "element-ui";
import axios from "axios";
import vueQr from 'vue-qr';
import refundDialog from "@/components/refundDialog";
export default {
  data() {
    return {
      ewmcenterDialogVisible:false,
      payImg:'',
      imagePath:require('../../assets/img/logo2.png'),
      category: window.localStorage.getItem("category"),
      channelId: "",
      listchannel: [],
      searchText: "",
      tableData: [],
      tableData4: [],
      formInline: {
        time: "",
        status: "",
        subChannel: "",
        begin: "", //开始时间
        end: "", //结束时间
        name: "", //姓名
        nationalId: "", //证件号
        branchId: "",
      },

      allpage: 0, //数据总数
      centerDialogVisible: false,
      centerDialogVisible1: false,
      exitData: {},
      billingState: [
        "创建",
        "线上支付完成",
        "挂帐月结-未付",
        "线下转账-已付款",
        "已退单",
        "投保失败退单",
      ],
    };
  },

  components: {
    refundDialog,
    vueQr
  },
  methods: {
    ckewm(url) {
      this.payImg = url
      this.ewmcenterDialogVisible = true
      console.log(url)
    },
    changePage(start, count) {
      this.getData(start, count);
    },
    setTime(str) {
      return common.time(str);
    },
    getData(start, count) {
      var start = start || 0; //当前页
      var count = count || 10; //每页多少个
      var day = "";
      if (this.formInline.time) {
        day = common.time1(this.formInline.time);
      }

      // if (this.formInline.begin) {
      // 	begin = common.time1(this.formInline.begin)
      // }
      // if (this.formInline.end) {
      // 	end = common.time1(this.formInline.end)
      // }
      console.log(this.formInline.end, this.formInline.begin);
      if (this.formInline.begin != "") {
        if (this.formInline.begin != null) {
          var begin = Date.parse(new Date(this.formInline.begin));
        } else {
          var begin = "";
        }
      }
      if (this.formInline.end != "") {
        if (this.formInline.end != null) {
          var end1 = Date.parse(new Date(this.formInline.end));
          var end = end1 + 24 * 60 * 60 * 1000 - 1;
        } else {
          var end = "";
        }
      }

      var data = {};
      if (window.localStorage.getItem("category") != 1) {
        if (this.formInline.subChannel != "") {
          data = {
            start,
            count,
            day,
            subChannel: this.formInline.subChannel,
            branchId:this.channelId,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        } else {
          data = {
            start,
            count,
            day,
            branchId:this.channelId,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        }
      } else {
        if (this.formInline.branchId != "") {
          data = {
            start,
            count,
            day,
            branchId: this.formInline.branchId,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        } else {
          data = {
            start,
            count,
            day,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
        }
      }

      getInfo()
        .then((res) => {
          console.log(res.data.obj.category);
          var datalist = {
            start: "0",
            count: 10000,
            state: this.formInline.status,
            begin: begin, //开始时间
            end: end, //结束时间
            name: this.formInline.name, //姓名
            nationalId: this.formInline.nationalId, // 证件号
          };
          if (data.day != "") {
            datalist.day = data.day;
          }
          if (res.data.obj.category != 1) {
            listchannel(datalist)
              .then((resa) => {
                console.log(resa, "215");
                if (resa.data.code == 0) {
                  this.listchannel = resa.data.obj;
                  this.ordergetChannelBillDetailList(data)
                  // this.formInline.subChannel=this.listchannel[0].id
                  // subChannel
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            userchannellist(datalist)
              .then((resb) => {
                console.log(resb, "335");
                if (resb.data.code == 0) {
                  this.listchannel = resb.data.obj;
                  this.ordergetChannelBillDetailList(data)
                  // this.formInline.subChannel=this.listchannel[0].id
                  // subChannel
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      

   
      if (this.formInline.begin != "") {
        if (this.formInline.begin != null) {
          var begin = Date.parse(new Date(this.formInline.begin));
        } else {
          var begin = "";
        }
      }
      if (this.formInline.end != "") {
        if (this.formInline.end != null) {
          var end1 = Date.parse(new Date(this.formInline.end));
          var end = end1 + 24 * 60 * 60 * 1000 - 1;
        } else {
          var end = "";
        }
      }
    },
    ordergetChannelBillDetailList(data) {
      ordergetChannelBillDetailList(data)
        .then((res) => {
          //  this.creatData=res.data.obj;
          res.data.obj.forEach((item) => {
            // console.log(item.detail.subChannel);
            for (var i = 0; i < this.listchannel.length; i++) {
              // console.log(this.listchannel[i].id)
              if(this.category != 1) {
                if (this.listchannel[i].id == item.detail.subChannel) {
                item.detail.subChannelName = this.listchannel[i].name;
                }
              }else {
                if (this.listchannel[i].id == item.detail.channelId) {
                item.detail.subChannelName = this.listchannel[i].name;
                }
              }
            
            }
            if (item.detail.extra != null) {
              try{item.detail.extra = JSON.parse(item.detail.extra);}catch(e){}
            }
            item.divisionDay = item.product.divisionDay;
            item.detail.mobileno = Number(item.detail.mobileno);
          });
          this.tableData = res.data.obj;
         
       

          this.allpage = res.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportsee() {
      var token = JSON.parse(window.localStorage.getItem("token")).data.obj
        .token;
      var day = common.time1(this.formInline.time);
      // var begin = common.time1(this.formInline.begin)
      // var end = common.time1(this.formInline.end)
      // name:this.formInline.name, //姓名
      // nationalId:this.formInline.nationalId// 证件号
      console.log(this.formInline.begin);
      if (this.formInline.begin != "") {
        if (this.formInline.begin != null) {
          var begin = Date.parse(new Date(this.formInline.begin));
        } else {
          var begin = "";
        }
      }
      if (this.formInline.end != "") {
        if (this.formInline.end != null) {
          var end1 = Date.parse(new Date(this.formInline.end));
          var end = end1 + 24 * 60 * 60 * 1000 - 1;
        } else {
          var end = "";
        }
      }
      console.log(end, begin);
      if (end == undefined) {
        end = "";
      }
      if (begin == undefined) {
        begin = "";
      }
      if (window.localStorage.getItem("category") != 1) {
        if (this.channelId == "2753" || this.channelId == "2137" || this.channelId == "2108") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.channelId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=1`;
        } else if(this.channelId == "3312" || this.channelId == "3118" || this.channelId == "1477") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.channelId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=3`;
        } else {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.channelId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=2`;
        }
      }else {
        if(this.formInline.branchId != '') {
          if (this.channelId == "2753" || this.channelId == "2137" || this.channelId == "2108") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.formInline.branchId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=1`;
        } else if(this.channelId == "3312" || this.channelId == "3118" || this.channelId == "1477") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.formInline.branchId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=3`;
        }else {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?branchId=${this.formInline.branchId}&day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=2`;
        }
        }else {
        if (this.channelId == "2753" || this.channelId == "2137" || this.channelId == "2108") {
        window.location = `${SEVERS}rescue_sale/order/exportOrderList?day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=1`;
        }else if(this.channelId == "3312" || this.channelId == "3118" || this.channelId == "1477") {
          window.location = `${SEVERS}rescue_sale/order/exportOrderList?day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=3`;
        } else {
          window.location = `${SEVERS}rescue_sale/order/exportOrderList?day=${day}&token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}&startts=${begin}&endts=${end}&name=${this.formInline.name}&nationalId=${this.formInline.nationalId}&exportType=2`;
        }
        }
      }
      console.log(window.location)
    },
    sureExit() {
      //退单
      console.log();
      var exitData = this.exitData.id;
      var data = {
        billDetailId: exitData,
      };
      refund(data)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "退单成功！",
              type: "success",
            });
            this.getData();
            this.centerDialogVisible1 = true;
          } else if (res.data.code == 105009) {
            this.$message.error("保障卡已激活不能退款！");
          } else if (res.data.code == 105014) {
            this.$message.error("退单失败！");
          } else if (res.data.code == 105015) {
            this.$message.error("部分退单失败！");
          } else if (res.data.code == 105042) {
            this.$message.error("部分退单失败！");
          }
          this.centerDialogVisible = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changePage(size, each) {
      this.getData(size, each);
    },
    downPdf(id) {
      var loadingInstance = Loading.service({ fullscreen: true });
      const httpAxios = axios.create(); //创建实例
      httpAxios.defaults.timeout = 1000 * 60 * 2;
      httpAxios
        .get(API_BASE_EWM + "rescue_sale/sale/download_pdf", {
          params: {
            token: JSON.parse(window.localStorage.getItem("token")).data.obj
              .token,
            id,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            loadingInstance.close();
            window.location = res.data.obj;
          }
        })
        .catch((err) => {
          console.log(err);
          loadingInstance.close();
        });
    },
  },
  mounted() {
    this.channelId = localStorage.getItem("channelId");
    this.getData();
    const clipboard = new Clipboard(".icon-copy");
    clipboard.on("success", (e) => {
      this.$message.success(e.text + " 已复制到剪贴板！");
    });
    clipboard.on("error", (e) => {
      console.log("该浏览器不支持自动复制");
      clipboard.destroy();
    });
  },
};
</script>
<style>
.has-gutter th {
  background-color: #f5f7fb;
}
</style>
<style scoped="scoped">
h3 {
  color: #333;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 20px;
}

.searchBox {
  margin-top: 20px;
}

.input {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/shop/Orderdetails1.vue